/* @flow */
/* eslint-disable babel/no-invalid-this */
import Dispatch from "nexia_mobile/flux_like/dispatch";
import type { LockLockFeature } from "./types";

export default function LockLock(feature: LockLockFeature) {
  let lockAction = feature.actions.lock;

  this.lock = () => {
    const promiseWithAbort = this.executeDeviceAction(lockAction, {});

    promiseWithAbort.then(() => {
      Dispatch("DEMO_MODE_EVENT", this, "Locked");
    });

    return promiseWithAbort;
  };

  return { isLocked: feature.is_locked };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/lock_lock.js